var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.39,
    height: 32.016,
    viewBox: "0 0 39.39 32.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_95",
    "data-name": "Gruppe 95",
    transform: "translate(-2897.23 -119.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_647",
    "data-name": "Pfad 647",
    d: "M2911.871,162.016l-9.152,8.535h-4.646a.794.794,0,0,0-.844.732v9a.794.794,0,0,0,.844.732h4.646l9.152,8.535a.866.866,0,0,0,1.46-.5V162.515A.866.866,0,0,0,2911.871,162.016Z",
    transform: "translate(0 -40.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_648",
    "data-name": "Pfad 648",
    d: "M3304.058,381.158a1.911,1.911,0,0,0,0,2.7,3.446,3.446,0,0,1,0,4.866,1.911,1.911,0,1,0,2.7,2.7,7.272,7.272,0,0,0,0-10.273A1.911,1.911,0,0,0,3304.058,381.158Z",
    transform: "translate(-387.497 -250.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_649",
    "data-name": "Pfad 649",
    d: "M3437.189,250.631a2.218,2.218,0,0,0-2.7,0,1.38,1.38,0,0,0,0,2.219,8.835,8.835,0,0,1,0,14.212,1.38,1.38,0,0,0,0,2.22,2.218,2.218,0,0,0,2.7,0,11.594,11.594,0,0,0,0-18.651Z",
    transform: "translate(-512.8 -124.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_650",
    "data-name": "Pfad 650",
    d: "M3567.619,120.235a2.1,2.1,0,0,0-2.7,0,1.55,1.55,0,0,0,0,2.385c8.2,7.239,8.2,19.018,0,26.257a1.55,1.55,0,0,0,0,2.386,2.1,2.1,0,0,0,2.7,0,20.165,20.165,0,0,0,0-31.028Z",
    transform: "translate(-638.281 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicYes);
export default __webpack_public_path__ + "static/media/music-yes.2509a6b5c13422b727ed8442a1cfc8dc.svg";
export { ForwardRef as ReactComponent };